import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_WordHighlighter = _resolveComponent("WordHighlighter");
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", {
    ref: "textOverflow",
    class: "text-overflow",
    style: _normalizeStyle($options.boxStyle)
  }, [_createVNode(_component_el_tooltip, _mergeProps($props.tooltipAttrs, {
    "popper-class": "popper",
    disabled: $data.tootip,
    content: $props.text
  }), {
    default: _withCtx(function () {
      return [_createVNode(_component_WordHighlighter, {
        query: $props.query,
        "highlight-style": "color:#FFFFFF;background: #5587FF;"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("span", {
            ref: "overEllipsis"
          }, _toDisplayString($props.text), 513)];
        }),
        _: 1
      }, 8, ["query"])];
    }),
    _: 1
  }, 16, ["disabled", "content"])], 4);
}